export enum ERole {
	STUDENT = "USER",
	INSTRUCTOR = "TEACHER",
}
